export const removeParam = async ({ commit }, { key, value }) => {
  commit('REMOVE_PARAM', { key, value })
}